import React from "react";
import { useViewPitches } from "../../hooks/viewpitches/useViewPitches";
import ViewPitchesScreen from "../../components/viewpitches/ViewPitchesScreen";

/**
 * The coach entrance to View Pitches. Same screen as the club and staff
 * routes; the coach has neither the club's Free-Agents filter nor a separate
 * inner life.
 */
const CoachViewPitches = () => {
  const vp = useViewPitches(true);

  if (!vp.tender) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F5F7FB]">
        <p className="text-[14px] text-[#6B7280]">
          Request data not found. Redirecting...
        </p>
      </div>
    );
  }

  return <ViewPitchesScreen {...vp} />;
};

export default CoachViewPitches;
